import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { MessageCircle, ArrowRight } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/constants";

const ITEMS = [
  {
    q: "Vocês fabricam peças totalmente sob projeto?",
    a: "Sim. Trabalhamos conforme desenho técnico, amostra ou especificação fornecida.",
  },
  {
    q: "Atendem demandas recorrentes?",
    a: "Sim. Oferecemos fornecimento contínuo conforme necessidade do cliente.",
  },
  {
    q: "Quais processos são feitos internamente?",
    a: "Corte a laser, dobra CNC, usinagem, caldeiraria leve, soldagem industrial e montagem final.",
  },
  {
    q: "Atendem somente São Paulo?",
    a: "Atendemos São Paulo e outras regiões conforme logística do projeto.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-20 sm:py-28 bg-white"
    >
      <div className="container-buzas">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <span className="eyebrow">Perguntas frequentes</span>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-[2.6rem] leading-[1.08] tracking-tight text-[var(--buzas-navy)]">
              Dúvidas reais dos nossos clientes sobre peças sob medida.
            </h2>
            <p className="mt-5 text-base text-[var(--buzas-muted)] leading-relaxed">
              Respostas objetivas para você avaliar com clareza a aplicação
              dos nossos processos na sua operação.
            </p>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="faq-whatsapp-link"
              className="mt-6 inline-flex items-center gap-2 text-[14px] font-bold text-[var(--buzas-red)] hover:text-[var(--buzas-red-dark)] transition-colors"
            >
              <MessageCircle size={16} />
              Não encontrou sua dúvida? Fale com um especialista
              <ArrowRight size={14} />
            </a>
          </div>

          <div className="lg:col-span-7">
            <Accordion
              type="single"
              collapsible
              defaultValue="item-0"
              data-testid="faq-accordion"
              className="w-full"
            >
              {ITEMS.map((item, i) => (
                <AccordionItem
                  key={item.q}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border border-[var(--buzas-border)] rounded-lg mb-3 px-5 sm:px-6 bg-white hover:border-[var(--buzas-navy)]/20 transition-colors data-[state=open]:border-[var(--buzas-navy)]/30 data-[state=open]:shadow-[0_12px_30px_-20px_rgba(26,43,86,0.3)]"
                >
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="py-5 text-left font-display text-[16px] sm:text-[17px] font-bold text-[var(--buzas-navy)] hover:no-underline data-[state=open]:text-[var(--buzas-navy)]"
                  >
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent
                    data-testid={`faq-content-${i}`}
                    className="pb-5 text-[15px] text-[var(--buzas-muted)] leading-relaxed"
                  >
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
